import FilterChip from 'LuxKit/Chips/FilterChip'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { Form } from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchChips'
import ModalContext from 'contexts/ModalContext'
import ModalCruiseSearchTravellerTypeChip from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/Modal/ModalCruiseSearchTravellerTypeChip'

export interface CruiseSearchTravellerTypeChipProps {
  facets: App.CruiseSearchFacetsV2
  filters: {
    travellerTypes?: Set<string>
  }
  filterForm: Form
  setFilterForm: (form: Form) => void
  fetching?: boolean
  drawerMode?: boolean
}

function CruiseSearchTravellerTypeChip(props: CruiseSearchTravellerTypeChipProps) {
  const { filters, facets, filterForm, setFilterForm, fetching, drawerMode } = props
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const openModal = useCallback(async() => {
    await showModal<number>(<ModalCruiseSearchTravellerTypeChip
      drawerMode={drawerMode}
      facets={facets}
      filterForm={filterForm}
      filters={filters}
      setFilterForm={setFilterForm}
      fetching={fetching}
    />)
  }, [drawerMode, facets, fetching, filterForm, filters, setFilterForm, showModal])

  const countSelected = useMemo(() => {
    return (filters.travellerTypes?.size || 0)
  }, [filters.travellerTypes?.size])

  const chipLabel = countSelected ?
      intl.formatMessage(
        {
          id: 'zNvSoKZhXmr-ivLH7V5g',
          defaultMessage: 'Traveller Type ({count})',
        },
        { count: countSelected },
      ) :
      intl.formatMessage({
        id: '-scD-p5Llk_v9aiRjUK7',
        defaultMessage: 'Traveller Type',
      })

  return <FilterChip
    selected={!!filters.travellerTypes && filters.travellerTypes.size > 0}
    size="medium"
    onClick={openModal}
    endIcon={<LineAngleDownIcon />}
  >
    {chipLabel}
  </FilterChip>
}

export default CruiseSearchTravellerTypeChip
